<template>
  <ModalLayout
    :id="id"
    v-model="openModalComputed"
    @click:cancel="handleCancelEdit"
    @click:save="handleSaveEdit"
    manual-hide
  >
    <div class="flex flex-col">
      <h2 class="text-xl mb-4">
        สร้างความสัมพันธ์กับ {{ selectingNameComputed }}
      </h2>
      <fieldset class="flex items-center mb-2">
        <label class="flex-shrink-0 mr-2 w-1/5">สมาชิก</label>
        <!-- <select class="form-select form-select-sm">
          <option>test</option>
        </select> -->
        <div class="w-4/5">
          <v-select
            data-test="people-selector"
            id="people-selector"
            class="w-full"
            :class="{ errorselect: nonValidName }"
            placeholder="กรุณาเลือกสมาชิก"
            :options="peopleOptionsComputed"
            label="label"
            :clearable="false"
            :reduce="(person) => person.value"
            v-model="name_input"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
            </template>
          </v-select>
          <p class="error-msg" v-if="nonValidName">กรุณาเลือกสมาชิก</p>
        </div>

        <!-- <input type="text" v-model="name_input" class="form-control"/> -->
      </fieldset>
      <fieldset class="flex items-center mb-2">
        <label class="flex-shrink-0 mr-2 w-1/5">ความสัมพันธ์</label>
        <div class="w-4/5">
          <v-select
            :disabled="!name_input"
            data-test="relation-selector"
            id="relation-selector"
            class="w-full"
            :class="{ errorselect: nonValidRelation }"
            placeholder="กรุณาเลือกความสัมพันธ์"
            :options="relationOptions"
            :clearable="false"
            v-model="relation_select"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
            </template>
          </v-select>
          <p class="error-msg" v-if="nonValidRelation">
            กรุณาเลือกความสัมพันธ์
          </p>
        </div>
      </fieldset>
    </div>
  </ModalLayout>
</template>

<script setup>
import { computed, ref } from "vue";
import ModalLayout from "../base/modal-layout/ModalLayout.vue";
import { RELARION_OPTION } from "./static/data";

const props = defineProps({
  modelValue: Boolean,
  peopleOptions: Array,
  id: String,
  selecting: {
    type: Object,
    default: null,
  },
});
const emits = defineEmits(["update:modelValue", "saveEdit", "cancelEdit"]);

// input
const name_input = ref(null);
const relation_select = ref(null);

// validateinput
const nonValidName = ref(false);
const nonValidRelation = ref(false);

const openModalComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});

const peopleOptionsComputed = computed(() => {
  return props.peopleOptions;
});

const relationOptions = computed(() => {
  let result = RELARION_OPTION;
  if (!props.selecting) return [];
  if (props.selecting.data.relation_node)
    return result.filter(
      (item) =>
        ![
          "คู่สมรส",
          "บิดา",
          "มารดา",
          "ลุง",
          "ป้า",
          "น้า",
          "อา",
          "พ่อ",
          "แม่",
          "พี่",
          "น้อง",
          "ปู่",
          "ย่า",
          "ตา",
          "ยาย",
          "ญาติพี่น้อง",
        ].includes(item)
    );
  if (name_input.value) {
    if (name_input.value.sex === "ชาย") {
      result = result.filter(
        (item) => !["มารดา", "ย่า", "ยาย", "ป้า"].includes(item)
      );
    } else if (name_input.value.sex === "หญิง") {
      result = result.filter(
        (item) => !["บิดา", "ปู่", "ตา", "ลุง"].includes(item)
      );
    }
  }
  return result;
});

const relationNodeComputed = computed(() => {
  if (props.selecting) return props.selecting.data.relation_node;
  return false;
});

const selectingNameComputed = computed(() => {
  if (props.selecting) {
    let nodedata = props.selecting.data.data;
    if (nodedata.source) {
      return `${nodedata.source.title}${nodedata.source.name} และ ${nodedata.target.title}${nodedata.target.name}`;
    }
    return `${nodedata.title}${nodedata.name}`;
  }
  return "";
});

const clearState = () => {
  name_input.value = "";
  relation_select.value = null;
  openModalComputed.value = false;
};

const handleCancelEdit = () => {
  emits("cancelEdit");
  clearState();
};
const handleSaveEdit = () => {
  const valid = validateInput();
  let tempMember = null;
  if (valid) {
    tempMember = {
      name: name_input.value.name,
      sex: name_input.value.sex,
      surname: name_input.value.surname,
      title: name_input.value.title,
      _id: name_input.value._id,
    };
    emits("saveEdit", tempMember, relation_select.value);
    clearState();
  }
};
const validateInput = () => {
  if (!name_input.value) nonValidName.value = true;
  else nonValidName.value = false;
  if (!relation_select.value) nonValidRelation.value = true;
  else nonValidRelation.value = false;
  if (nonValidName.value || nonValidRelation.value) return false;
  return true;
};
</script>
